<div class="container">
    <div>
        <img height="90" width="90" src="loader.gif" alt="Loading..." />
    </div>
</div>
